import React from 'react'
import Navbar from '../components/Navbar'
import SevenYearModel from '../components/SevenYearModel'
// SevenYearModel

const SevenYearModelPage = () => {
  return (
    <div>

        <Navbar />
        <br />
        <br />
        <br />
        <br />
        <SevenYearModel/>
    </div>
  )
}

export default SevenYearModelPage